/* Bloque de compra de la ficha de producto: fecha de entrega (al lado de la cantidad), iconos de pago bajo los
   botones y traducción de "More payment options". Se carga en todas las páginas (doc-head-core) y se ejecuta en
   la ficha de producto, en la compra rápida, en los productos destacados y cada vez que el tema repinta el
   bloque (cambio de variante, etc.): los <script> inline no se ejecutan en esos casos, por eso vive aquí y vigila
   la página. El HTML trae un texto por defecto por si el script no llega. */
(function () {
  if (window.__estDeliveryLoaded) { window.__estDeliveryRender && window.__estDeliveryRender(); return; }
  window.__estDeliveryLoaded = true;

  // ===== AJUSTA ESTO =====
  // min / max = días laborables de transporte
  // corte = hora límite lun-jue · corteViernes = hora límite viernes
  var PLAZOS = {
    DEFAULT: { min: 1, max: 2, corte: 15, corteViernes: 16 },  // España y resto
    DE:      { min: 3, max: 5, corte: 14, corteViernes: 14 },  // Alemania
    AT:      { min: 3, max: 5, corte: 14, corteViernes: 14 },  // Austria
    IT:      { min: 3, max: 5, corte: 14, corteViernes: 14 }   // Italia
  };
  var FESTIVOS = [
    '2026-10-12', '2026-12-08', '2026-12-25',
    '2027-01-01', '2027-01-06'
  ];
  // [etiqueta pequeña, separador entre fechas]
  var TEXTOS = {
    es: ['Compra ahora y recíbelo entre', 'y'],
    de: ['Jetzt bestellen und erhalten zwischen', 'und'],
    it: ['Ordina ora e ricevi tra', 'e']
  };
  // Aviso de hora límite ("Pídelo antes de las 15:00 y sale hoy mismo"). Desactivado: ponlo en true para volver a mostrarlo.
  var MOSTRAR_CORTE = false;
  var CORTE_TEXTOS = {
    es: function (h) { return 'Pídelo antes de las ' + h + ':00 y sale hoy mismo'; },
    de: function (h) { return 'Bestelle vor ' + h + ':00 Uhr – Versand noch heute'; },
    it: function (h) { return 'Ordina entro le ' + h + ':00 e parte oggi stesso'; }
  };
  // Texto por defecto (el mismo que pone el snippet desde el servidor)
  var DEFECTO = { es: 'Recíbelo en 24-48 h laborables', de: 'Lieferung in 3–5 Werktagen', it: 'Consegna in 3-5 giorni lavorativi' };
  // Traducción del enlace que escribe Shopify en inglés (solo si la página está en inglés)
  var MAS_PAGOS = {
    ES: 'Más opciones de pago', PT: 'Mais opções de pagamento',
    DE: 'Weitere Zahlungsoptionen', AT: 'Weitere Zahlungsoptionen',
    IT: 'Altre opzioni di pagamento'
  };
  // Botón de la barra fija de compra en móvil (lo crea klayful-reveal.js en español)
  var STICKY = { de: 'Ich will es', it: 'Lo voglio' };
  // =======================

  function iso(d) {
    var m = d.getMonth() + 1, day = d.getDate();
    return d.getFullYear() + '-' + (m < 10 ? '0' : '') + m + '-' + (day < 10 ? '0' : '') + day;
  }
  function isBiz(d) {
    return d.getDay() !== 0 && d.getDay() !== 6 && FESTIVOS.indexOf(iso(d)) === -1;
  }
  function addBiz(d, n) {
    d = new Date(d);
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      if (isBiz(d)) n--;
    }
    return d;
  }

  function country() {
    return (window.Shopify && window.Shopify.country) || '';
  }

  // Estilos de la fecha de entrega: tarjeta de marca al lado del selector de cantidad.
  // La rejilla solo coloca etiqueta, cantidad, fecha y botón de añadir; cualquier otro hijo de la fila
  // (botón de pago rápido, "más opciones de pago"...) ocupa todo el ancho como antes.
  // Sin selector de cantidad la fecha queda como tarjeta a todo el ancho encima del botón.
  function ensureStyles() {
    if (document.getElementById('est-delivery-css2')) return;
    var G = '.quantity-submit-row:has(> quantity-wrapper):has(> .est-delivery)';
    var st = document.createElement('style');
    st.id = 'est-delivery-css2';
    st.textContent =
      '.est-delivery{display:flex;align-items:center;gap:10px;font-size:14px;margin:12px 0;line-height:1.3}' +
      '.quantity-submit-row__submit > .est-delivery{padding:8px 12px;border-radius:14px;background:#f4f7f6;border:1px solid #bbccca}' +
      '.est-dot{width:8px;height:8px;border-radius:50%;background:#3bb54a;flex:none;margin-top:0;position:relative}' +
      '.est-dot::after{content:"";position:absolute;inset:0;border-radius:50%;background:#3bb54a;animation:est-pulse 2s ease-out infinite}' +
      '.est-cutoff{display:block;font-size:13px;opacity:.75}' +
      '.est-cutoff[hidden]{display:none}' +
      '.est-label{display:block;font-size:12px;opacity:.75;margin-bottom:3px}' +
      '.est-dates{display:flex;flex-wrap:wrap;align-items:center;gap:2px 6px;font-size:14px}' +
      '.est-dates strong{white-space:nowrap}' +
      '.est-sep{opacity:.55;font-size:12px}' +
      G + '{display:grid;grid-template-columns:max-content minmax(0,1fr);column-gap:14px;align-items:center}' +
      G + ' > *{grid-column:1/-1}' +
      G + ' > .label{grid-row:1}' +
      G + ' > quantity-wrapper{grid-column:1;grid-row:2;justify-self:start;align-self:center}' +
      G + ' > .est-delivery{grid-column:2;grid-row:2;margin:0;padding:8px 12px;border-radius:14px;background:#f4f7f6;border:1px solid #bbccca;overflow:hidden;position:relative;animation:est-in .7s cubic-bezier(.2,.8,.2,1) both}' +
      G + ' > .est-delivery::before{content:"";position:absolute;inset:0;background:linear-gradient(110deg,transparent 35%,rgba(255,255,255,.7) 50%,transparent 65%);transform:translateX(-120%);animation:est-shine 5s ease-in-out 1.2s infinite;pointer-events:none}' +
      G + ' > .quantity-submit-row__submit{grid-row:3}' +
      '@keyframes est-pulse{0%{transform:scale(1);opacity:.55}100%{transform:scale(3.2);opacity:0}}' +
      '@keyframes est-in{from{opacity:0;transform:translateX(-10px)}to{opacity:1;transform:none}}' +
      '@keyframes est-shine{0%,60%{transform:translateX(-120%)}100%{transform:translateX(120%)}}' +
      '@media (max-width:480px){.est-label{font-size:11px}.est-dates{font-size:13px}' + G + '{column-gap:10px}}' +
      '@media (prefers-reduced-motion:reduce){.est-dot::after,.est-delivery,.est-delivery::before{animation:none!important}}';
    document.head.appendChild(st);
  }

  // Productos destacados y otros sitios con botón de compra que no traen el bloque
  function inject() {
    document.querySelectorAll('.quantity-submit-row__submit').forEach(function (sub) {
      if (sub.querySelector('.est-delivery')) return;
      var row = sub.closest('.quantity-submit-row');
      if (row && row.querySelector(':scope > .est-delivery')) return;
      var btn = sub.querySelector('button[type="submit"]');
      if (!btn || btn.disabled) return;
      ensureStyles();
      var pais = country();
      var lg = (pais === 'DE' || pais === 'AT') ? 'de' : (pais === 'IT' ? 'it' : 'es');
      var el = document.createElement('div');
      el.className = 'est-delivery';
      el.setAttribute('data-country', pais);
      el.innerHTML = '<span class="est-dot"></span><span class="est-body"><span class="est-text"></span><span class="est-cutoff" hidden></span></span>';
      el.querySelector('.est-text').textContent = DEFECTO[lg];
      sub.insertBefore(el, sub.firstChild);
    });
  }

  // La fecha va como hijo directo de la fila (al lado de la cantidad, la rejilla CSS la coloca).
  // Solo se mueve una vez (si ya es el primer hijo no se toca, para no reactivar el observador).
  function placeDate() {
    document.querySelectorAll('.quantity-submit-row__submit .est-delivery').forEach(function (el) {
      ensureStyles();
      var row = el.closest('.quantity-submit-row');
      if (!row || !row.firstElementChild) return;
      if (!row.querySelector('quantity-wrapper')) return;
      if (row.firstElementChild === el) return;
      row.insertBefore(el, row.firstElementChild);
    });
  }

  // Mueve los iconos de pago justo debajo de los botones de compra
  function placePay() {
    document.querySelectorAll('.pay-icons-src').forEach(function (src) {
      var row = src.closest('.quantity-submit-row');
      if (!row) return;
      var next = row.nextElementSibling;
      if (!(next && next.classList.contains('pay-icons-wrap'))) {
        var wrap = document.createElement('div');
        wrap.className = 'pay-icons-wrap';
        wrap.innerHTML = src.innerHTML;
        row.parentNode.insertBefore(wrap, row.nextSibling);
      }
      src.remove();
    });
  }

  // "More payment options" lo escribe Shopify en el idioma de la página (inglés aquí)
  function translateMore() {
    var txt = MAS_PAGOS[country()];
    if (!txt) return;
    if ((document.documentElement.lang || '').slice(0, 2) !== 'en') return;
    document.querySelectorAll('.shopify-payment-button__more-options').forEach(function (b) {
      if (/^\s*more payment options\s*$/i.test(b.textContent)) b.textContent = txt;
    });
  }

  // Barra fija de compra en móvil: el botón se crea en español, aquí se pasa al idioma de la página
  function translateSticky() {
    var lg = (document.documentElement.lang || '').slice(0, 2);
    var txt = STICKY[lg];
    if (!txt) return;
    var b = document.querySelector('.kb-sticky__b');
    if (b && b.textContent !== txt) b.textContent = txt;
  }

  function fill(el) {
    if (el.getAttribute('data-ready')) return;
    var textEl = el.querySelector('.est-text');
    if (!textEl) return;
    ensureStyles();
    var pais = el.getAttribute('data-country');
    var P = PLAZOS[pais] || PLAZOS.DEFAULT;
    var lang = (pais === 'DE' || pais === 'AT') ? 'de'
             : (pais === 'IT') ? 'it'
             : (document.documentElement.lang || 'es').slice(0, 2);

    // hora actual en España, sin depender del reloj del cliente
    var now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Madrid' }));

    // día en que sale el pedido según la hora de corte
    var corte = now.getDay() === 5 ? P.corteViernes : P.corte;
    var enHora = isBiz(now) && now.getHours() < corte;
    var dispatch = new Date(now);
    if (!enHora) dispatch = addBiz(now, 1);

    var f = new Intl.DateTimeFormat(lang === 'de' ? 'de-DE' : (lang === 'it' ? 'it-IT' : 'es-ES'),
      { weekday: 'short', day: 'numeric', month: 'short' });
    var fmt = function (d) {
      var s = f.format(d).replace(/[.,]/g, '');
      return s.charAt(0).toUpperCase() + s.slice(1);
    };
    var t = TEXTOS[lang] || TEXTOS.es;

    textEl.innerHTML =
      '<span class="est-label">' + t[0] + '</span>' +
      '<span class="est-dates"><strong>' + fmt(addBiz(dispatch, P.min)) + '</strong>' +
      '<span class="est-sep">' + t[1] + '</span>' +
      '<strong>' + fmt(addBiz(dispatch, P.max)) + '</strong></span>';

    var cutEl = el.querySelector('.est-cutoff');
    if (cutEl) {
      if (MOSTRAR_CORTE && enHora) {
        cutEl.textContent = (CORTE_TEXTOS[lang] || CORTE_TEXTOS.es)(corte);
        cutEl.hidden = false;
      } else {
        cutEl.hidden = true;
      }
    }
    el.setAttribute('data-ready', '1');
  }

  function render() {
    inject();
    placeDate();
    placePay();
    translateMore();
    translateSticky();
    document.querySelectorAll('.est-delivery:not([data-ready])').forEach(fill);
  }
  window.__estDeliveryRender = render;

  render();
  document.addEventListener('DOMContentLoaded', render);
  // compra rápida
  document.addEventListener('on:quickbuy:after-open', render);
  // cualquier otro repintado del bloque (cambio de variante, botón de pago que carga tarde...)
  if (window.MutationObserver) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; render(); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
